import { useWorkOrderControllerGetWorkOrderRelatedItems } from '@/generated/api/work-order.ts';
import { WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS } from '../autoRefresh.ts';

export default function useWorkOrderRelatedItems(workOrderId?: string) {
  return useWorkOrderControllerGetWorkOrderRelatedItems(workOrderId ?? '', {
    query: {
      ...WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS,
      enabled: Boolean(workOrderId),
    },
  });
}
